import { Types } from '@jumpcloud/ui-components';

const { Column } = Types;

export const keyTypes = {
  deviceBiometric: 'deviceBiometricCredentials',
  securityKey: 'securityKeyCredentials',
  legacy: 'legacyCredentials',
};

const getNameFieldLabel = (type) => (type === keyTypes.deviceBiometric ? 'Device Type' : 'Display Name');
export const getColumns = (type) => [
  Column({
    label: getNameFieldLabel(type),
    dataFieldName: 'name',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: 'Registered Date',
    dataFieldName: 'registeredDate',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: '',
    dataFieldName: 'action',
    width: '48px',
  }),
];

export const getHeader = (type) => {
  switch (type) {
    case keyTypes.deviceBiometric:
      return 'Device Authenticator (WebAuthn)';
    case keyTypes.securityKey:
      return 'Security Keys (WebAuthn)';
    default:
      return 'Legacy Keys (WebAuthn)';
  }
};

export const getDeleteModalHeader = ({ attachment }) => {
  switch (attachment) {
    case 'platform':
      return 'Delete Device Authenticator';
    case 'cross-platform':
      return 'Delete Security Key';
    default:
      return 'Delete Legacy Key';
  }
};

export const getDeleteBodyTextDeviceType = ({ attachment }) => (attachment === 'platform' ? 'device authenticator' : 'key');
